export enum AppGroup {
    FBIClients = 0,
    FBITalent,
    FBIReports,
    FBIDocumentation,
    Administration
}